// instagram
let instagram = new Swiper(".feed", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    mousewheel: true,
    breakpoints: {
        550: {
            slidesPerView: 2.3
        },
        750: {
            slidesPerView: 3.6
        },
        1440: {
            slidesPerView: 6
        }
    }
})

const bodyTag = document.querySelector("body")
    
const closeSizeGuideButton = document.querySelector(".close-size-guide")

if (closeSizeGuideButton) {
    closeSizeGuideButton.addEventListener("click", function (e) {
        bodyTag.classList.remove("size-guide-open")
        bodyTag.classList.remove("overflow-hidden")
        e.preventDefault()
    })
}

// conversion of units
const units = document.querySelectorAll(".unit")
const dimensions = document.querySelectorAll("span[data-unit]")
units.forEach(unit => {
    unit.addEventListener("click", function (e) {
        units.forEach(unit => {
            unit.classList.remove("active")
        })

        unit.classList.add("active");

        const selectedUnit = this.dataset.unit
        console.log(selectedUnit)

        dimensions.forEach(dimension => {
            if (dimension.dataset.unit == selectedUnit) {
                dimension.removeAttribute("hidden")
            } else {
                dimension.setAttribute("hidden", "hidden")
            }
        })

        e.preventDefault()
    })
})

// policy page navigation

const policyLinks = document.querySelectorAll(".on-page-link")
policyLinks.forEach(link => {
  link.addEventListener("click", function (event) {
    console.log("Hi")
    event.preventDefault();
    const sectionId = this.dataset.section;
    const view = document.querySelector(sectionId);
    view.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    console.log(hrefValue)
  })
})